export const RETAIL_INPUTS = {
  NAME: 'name',
  EMAIL: 'email',
  PHONE: 'phoneNumber',
  INVENTORY: 'inventoryLink',
  PRICE: 'price',
  NOTES: 'description',
  BLUR_BACKGROUND: 'blurBackground'
};

export const RETAIL_INPUTS_VARIANTS = {
  INFO: 'info',
  ERROR: 'error'
};

export const RETAIL_PATHS = {
  CREATE: `/retail/trade/{tradeId}`,
  GET: `/retail/token/{guid}`
};

export const CAROUSEL_NAVIGATE = {
  prev: 37,
  next: 39
};

export const CAROUSEL_LENGTH = {
  DEFAULT: 4,
  LIGHTBOX: 9
};

export const INTERNAL_LINKS = {
  TIAH_REGION: '&region=1',
  DIRECTIONS_LINK: 'https://www.google.com/maps/place/'
};

export const LIMITS = {
  NOTES: 4096
};

export enum VerificationStatus {
  CANCELLED = 'cancelled',
  APPROVED = 'approved',
  PENDING = 'pending'
}

// Canada exteme points
export const CANADA_BOUNDS = {
  north: 83.111389,
  south: 41.909167,
  west: -141.001944,
  east: -52.619444
};

// At any zoom above this label < 13 the google maps is not going to show labels to improve performance
export const MAXIMUM_ZOOM_WITH_LABEL = 13;

export const DEFAULT_ZOOM_LEVEL = 15;

export const DEFAULT_MAP_CENTER = {
  lat: 43.649266,
  lng: -79.391185
};

export const VEHICLE_TYPE = {
  new: 'new',
  used: 'used',
  notsure: 'notSure'
};

export const RetailMediaType = {
  IMAGE: 'IMAGE',
  DAMAGE: 'DAMAGE',
  VIDEO: 'VIDEO'
};

export const RetailCreateSource = {
  Header: 'TR 5 header',
  Footer: 'TR 5 footer'
};

export const RetailPlatforms = {
  Web: 'web',
  Mobile: 'mobile'
};

export const RetailVehicleFeatures = {
  DECODED: 'VIN decode',
  CARRYOVER: 'TR carryover'
};

export enum Province {
  ON = 'Ontario',
  QC = 'Québec',
  NS = 'Nova Scotia',
  NB = 'New Brunswick',
  MB = 'Manitoba',
  BC = 'British Columbia',
  PE = 'Prince Edward Island',
  SK = 'Saskatchewan',
  AB = 'Alberta',
  NL = 'Newfoundland and Labrador',
  NT = 'Northwest Territories',
  YT = 'Yukon',
  NU = 'Nunavut'
}

export function provinceShortName(province: Province) {
  switch (province) {
    case Province.ON:
      return 'ON';
    case Province.QC:
      return 'QC';
    case Province.NS:
      return 'NS';
    case Province.MB:
      return 'MB';
    case Province.BC:
      return 'BC';
    case Province.PE:
      return 'PE';
    case Province.SK:
      return 'SK';
    case Province.AB:
      return 'AB';
    case Province.NL:
      return 'NL';
    case Province.YT:
      return 'YT';
    case Province.NU:
      return 'NU';
    default:
      return '';
  }
}

export const UserSubscriptionPlan = {
  PRO: 'Pro',
  STANDARD: 'Standard'
};
